var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "py-0",
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "gg-card-title",
                {
                  staticClass: "pt-0 pb-0"
                },
                [_vm._v(" Managing domain " + _vm._s(_vm.domain.domain) + " ")]
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "v-tabs",
                {
                  attrs: {
                    flat: "",
                    "background-color": "transparent"
                  }
                },
                [
                  _c("v-tabs-slider", {
                    attrs: {
                      color: "green"
                    }
                  }),
                  _c(
                    "v-tab",
                    {
                      attrs: {
                        exact: "",
                        disabled: _vm.loading,
                        to: "/domains/".concat(_vm.domainid)
                      }
                    },
                    [_vm._v(" Overview ")]
                  ),
                  _c(
                    "v-tab",
                    {
                      attrs: {
                        exact: "",
                        disabled: _vm.loading,
                        to: "/domains/".concat(_vm.domainid, "/whois")
                      }
                    },
                    [_vm._v(" WHOIS ")]
                  ),
                  _c(
                    "v-tab",
                    {
                      attrs: {
                        exact: "",
                        disabled: _vm.loading,
                        to: "/domains/".concat(_vm.domainid, "/nameservers")
                      }
                    },
                    [_vm._v(" Nameservers ")]
                  )
                ],
                1
              ),
              _c("hr", {
                staticClass: "mt-0"
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "xs-12"
            },
            [
              _c(
                "gg-loading",
                {
                  attrs: {
                    loading: _vm.loading,
                    type: "table"
                  }
                },
                [_c("router-view")],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }